module.exports = __webpack_public_path__ + "img/gld_gbt819_1_2000.prt.28b14f43.jpg";